import Loadable from 'react-loadable';
import Loading from './loadingComponent';

export default (func) =>
    Loadable({
        loader: func,
        loading: Loading,
        delay: 300,
    });
